// Byte-exact mirror of `BuddyRenderer.sol`'s `DESCRIPTION` constant.
// Rendered in the `DESCRIPTION` section on `/` and used as the page meta
// description. Edited in lockstep with the Solidity source, never ahead.

export const DESCRIPTION =
  'One account. One buddy. Lives on-chain. No host. No takedown.';
